<script>
export default {
  name: "add",
}
</script>

<template>
  <svg data-v-f170a0fb="" xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 21 21"><g fill="none" fill-rule="evenodd" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><path d="M5.5 10.5h10M10.5 5.5v10"></path></g></svg>
</template>
